// import { Button } from 'app-template-lib/components/shadcn';
import { FETCH_M_LG_CONFIG } from '../queries/setting_m_lg_config.queries.type';
import { useState } from 'react';
import { Link } from 'react-router-dom';

type HeaderPresenterProps = {
    data: FETCH_M_LG_CONFIG;
};

export default function HeaderPresenter(props: HeaderPresenterProps) {
    const { data } = props;
    const [isOpen, setIsOpen] = useState(false);

    return (
        <header className="flex h-30 items-center gap-2 border-b bg-primary">
            <div className="flex-col md:flex">
                <div className="flex-1 space-y-4 md:p-4 pt-3 py-3">
                    <div className="flex items-center justify-between space-y-2 ">
                        <a href="/toppage/313718/2026" className="flex">
                            <div className="flex items-center mr-2">
                                <img title="icon" src="/pub-icon.png" className="max-h-[56px]" />
                            </div>
                            <div>
                                <h2 className="md:text-md text-md font-medium text-white flex mt-2">
                                    {data.setting_m_lg_config[0].city_name}
                                </h2>
                                <h2 className="md:text-lg text-md font-medium text-white flex mb-2">まちの事業マップ</h2>
                            </div>
                        </a>
                    </div>
                </div>
            </div>

            <div className="ml-auto px-3 mr-[10px]">
                {/* ナビゲーションメニュー（PC用） */}
                <nav className="hidden md:flex space-x-10 ">
                    {/* <Link to={`/about/${data.setting_m_lg_config[0].lgcode}`} className="hover:text-gray-600  text-black ">
                        本サイトについて
                    </Link>

                    <Link to={`/contact/${data.setting_m_lg_config[0].lgcode}`} className="hover:text-gray-600  text-black ">
                        お問い合わせ
                    </Link> */}
                </nav>

                {/* ハンバーガーメニュー（モバイル用） */}
                {/* <Button variant="ghost" size="icon" className="md:hidden" onClick={() => setIsOpen(!isOpen)}>
                    {isOpen ? <X size={24} /> : <Menu size={24} />}
                </Button> */}
            </div>
            {/* モバイルメニュー（開閉可能） */}
            {/* {isOpen && (
                <nav className="md:hidden bg-white border-t">
                    <ul className="flex flex-col space-y-3 p-4">
                        <li>
                            <Link to="/" className="block" onClick={() => setIsOpen(false)}>
                                Home
                            </Link>
                        </li>
                        <li>
                            <Link to="/about" className="block" onClick={() => setIsOpen(false)}>
                                About
                            </Link>
                        </li>
                        <li>
                            <Link to="/contact" className="block" onClick={() => setIsOpen(false)}>
                                Contact
                            </Link>
                        </li>
                    </ul>
                </nav>
            )} */}
        </header>
    );
}
